import { Box, Typography } from "@mui/material";
import React from "react";

interface ActivityFieldProps {
  children: React.ReactNode;
}
export const ActivityField: React.FC<ActivityFieldProps> = (props) => {
  const { children } = props;
  return (
    <Box
      sx={{
        p: "8px 12px",
        border: "1px solid",
        borderColor: "backgroundAlpha.main",
        borderRadius: 1,
      }}
    >
      <Typography variant="body2" color="text.tier" sx={{ overflowWrap: "break-word" }}>
        {children}
      </Typography>
    </Box>
  );
};

export default ActivityField;
